export type AuthMode = 'INTERNAL' | 'EXTERNAL_DEMO' | 'EXTERNAL_MSAD';

export const AuthMode = {
  INTERNAL: 'INTERNAL' as AuthMode,
  EXTERNAL_DEMO: 'EXTERNAL_DEMO' as AuthMode,
  EXTERNAL_MSAD: 'EXTERNAL_MSAD' as AuthMode,
};
